export default __webpack_public_path__ + "static/media/search-android.5b823d19791d865e2139d7e4b6a15490.svg";